import {Skeleton, Box} from '@mui/material';

const InquiryFeeSkeleton = () => {
    const skeletonItems = Array.from({length: 7});

    return (
        <Box className="centerClass primaryColorLight-900">
            <Skeleton
                variant="text"
                width="80%"
                sx={{
                    fontSize: '1rem',
                    margin: '0 auto',
                    paddingLeft: '30px',
                    paddingRight: '30px',
                    paddingTop: '10px',
                }}
            />
            {skeletonItems.map((_, index) => (
                <Box key={index} sx={{marginBottom: '10px'}}>
                    <Skeleton variant="rectangular" height={30} />
                </Box>
            ))}
        </Box>
    );
};

export default InquiryFeeSkeleton;
